<template>
  <div>
    <div class="box" v-for="(item, index) in list" :key="index">
      <div class="contentBox">
        <div class="title">
          <div class="methodTitle top">
          </div>
          <div class="methodTitle">
            <h3>订单号:</h3>
            <h3 class="flexTwo">{{ item.purNo }}</h3>
          </div>
          <div class="methodTitle bottom">
            <h3>物流单号:</h3>
            <h3 class="flexTwo">{{ item.expressNo }}</h3>
          </div>
        </div>
      </div>
      <van-divider dashed></van-divider>
      <div class="methodSlidebt">
        <ul>
          <li> <h3>状态：</h3> <p>{{ item.status }}</p> </li>
          <li> <h3>数量：</h3> <p>{{ item.quantity }}</p> </li>
          <li> <h3>合计：</h3> <p>{{ item.totalAmount }}</p> </li>
        </ul>
        <div v-if="flag" class="btn">
          <van-button v-show="item.status === '已发货'" plain size="small" color="#FF4427" @click="boxBtn(item.orderId, 'xq')">详情</van-button>
          <van-button v-show="item.status !== '已发货'" plain size="small" color="#FF4427" @click="boxBtn(item.orderId, 'fh')">发货</van-button>
        </div>
        <div v-else class="btn">
          <van-button plain size="small" color="#FF4427" @click="boxBtn(item.orderId, 'xq')">详情</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAdmin } from '@/api/orther.js'
export default {
  components: {},
  props: {
    list: {
      type: Array
    }
  },
  data () {
    return {
      flag: false
    }
  },
  watch: {},
  computed: {},
  methods: {
    async getAdmin () {
      const { data: res } = await getAdmin({ token: this.$store.state.token, userId: this.$store.state.userID.split('a')[0] })
      if (res.extend.userType === '1') {
        this.flag = true
      }
    },
    boxBtn (e, type) {
      if (type === 'xq') {
        this.$router.push({ name: 'PurchaseXQ', params: { orderId: e } })
      } else {
        this.$router.push({ name: 'DeliverGood', params: { orderId: e } })
      }
    }
  },
  beforeCreate () {},
  created () {
    this.getAdmin()
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  /deep/.van-cell__value {
    flex: 2;
  }
  .ckxq {
    /deep/.van-cell__value {
      color: rgb(42, 111, 238)!important;
    }
  }
  .weappIcon {
    font-size: 40px;
    line-height: inherit;
  }
  [class*=van-hairline]::after {
    border: none;
  }
  .box {
    width: 100%;
    height: 280px;
    background-color: #fff;
    margin: 0 auto 20px;
    box-shadow: 0 4px 10px 5px rgba(15,27,115,8%);
    border-radius: 15px;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .contentBox {
      width: 100%;
      display: flex;
      .title {
        width: 100%;
        .methodTitle {
          display: flex;
          justify-content: space-between;
          padding: 20px 0 0 40px;
          h3 {
            flex: 1;
            font-size: 30px;
            color: #272729;
            line-height: 20px;
            font-weight: 400;
          }
          .flexTwo {
            flex: 2;
          }
        }
        .bottom {
          margin-bottom: 20px;
        }
        .top {
          padding-top: 50px;
        }
      }
    }
    .van-divider {
      border-color: red;
      margin: 20px 0 10px;
    }
    .methodSlidebt {
      flex: 1;
      width: 100%;
      display: flex;
      align-items: baseline;
      align-content: center;
      ul {
        flex: 3;
        display: flex;
        justify-content: space-around;
        margin-top: 20px;
        li {
          display: flex;
          flex-direction: row;
          align-items: baseline;
          justify-content: space-around;
          h3 {
            font-size: 25px;
            color: #9D9DA3;
          }
          p {
            font-size: 25px;
            color: #272729;
          }
        }
      }
      .btn {
        flex: 1;
        text-align: center;
        padding: 0 0 15px;
        position: relative;
        .van-button {
          position: absolute;
          top: -25px;
          left: 40px;
          width: 90px;
          border-radius: 15px;
        }
      }
    }
  }
  .box:after {
    display: block;
    content: "";
    width: 32px;
    height: 32px;
    background: url(../assets/yans-2.png) no-repeat;
    background-size: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
</style>
